import { StorageService } from '@/services/storage.service';
import { getBrowserLocales } from '@/util/i18n/get-browser-locales';
import { getSupportedLocale } from '@/util/i18n/get-supported-locale';

export const startingLocale = getStartingLocale();

export function getStartingLocale() {
  const localStorageLocale = StorageService.getLocale();

  if (localStorageLocale) return localStorageLocale;

  const browserLocales = getBrowserLocales();

  const locale = getSupportedLocale(browserLocales) || Config.i18n.defaultLocale;

  StorageService.setLocale(locale);

  return locale;
}
